const handleFormFieldFocus = (elementName: Record<string, string>) => {
  const errorElement: HTMLElement = document.querySelector(
    `[name='${Object.keys(elementName)[0]}']`
  );
  errorElement?.focus();
};

export default handleFormFieldFocus;
